import React from "react"

import { WithID } from "shared/types/WithID"

import { Row } from "./row/Row"
import { TableItemProps } from "./types"

function TableItemComponent<I extends WithID>(props: TableItemProps<I>) {
  return <Row {...props} />
}

export const TableItem = React.memo(
  TableItemComponent
) as typeof TableItemComponent
